import React from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

const CONTACT_EMAIL = 'contact@squarebitstudios.com';

export const ContactPage = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = React.useState(false);
  const copyEmail = () => {
    navigator.clipboard.writeText(CONTACT_EMAIL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-[24px] py-[80px] text-center">
      <span className="font-mono text-[10px] tracking-[0.16em] uppercase text-[#818185] dark:text-[#A0A0A3] mb-[16px] font-bold">
        {t('contact.label')}
      </span>

      <h1 className="font-display font-bold text-[36px] md:text-[48px] tracking-[-0.03em] leading-[1.1] text-base-black dark:text-white mb-[16px]">
        {t('contact.title')}
      </h1>

      <p className="font-body text-[15px] text-[#818185] dark:text-[#A0A0A3] leading-relaxed max-w-[420px] mb-[40px]">
        {t('contact.description1')}
        <br />
        {t('contact.description2')}
      </p>

      <div className="flex flex-col sm:flex-row items-center gap-[12px] w-full sm:w-auto px-[16px] sm:px-0">
        <button
          type="button"
          onClick={copyEmail}
          className="h-[52px] sm:h-[56px] px-[20px] sm:px-[32px] rounded-[32px] bg-[#1D1D1E] dark:bg-[#C8C8CB] text-white dark:text-[#1C1C1F] font-body text-[13px] sm:text-[15px] font-medium hover:bg-[#2E2E30] dark:hover:bg-[#D8D8DB] transition-all flex items-center justify-center gap-[10px] w-full sm:w-auto relative"
        >
          {/* Invisible email text to maintain button width */}
          <span className="invisible flex items-center gap-[10px]">
            <svg width="18" height="18" viewBox="0 0 24 24" className="flex-shrink-0"><rect /></svg>
            <span>{CONTACT_EMAIL}</span>
          </span>
          {/* Visible content positioned absolutely */}
          <span className="absolute inset-0 flex items-center justify-center gap-[10px]">
            {copied ? (
              <>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>Copied!</span>
              </>
            ) : (
              <>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                </svg>
                <span className="truncate">{CONTACT_EMAIL}</span>
              </>
            )}
          </span>
        </button>

        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="w-[52px] h-[52px] sm:w-[56px] sm:h-[56px] rounded-full border-[1.5px] border-[#E5E5ED] dark:border-[rgba(255,255,255,0.08)] bg-[#F7F7F8] dark:bg-[#28282B] text-[#818185] dark:text-[#A0A0A3] hover:bg-[#E0E0E3] dark:hover:bg-[#333336] hover:text-base-black dark:hover:text-white transition-all flex items-center justify-center flex-shrink-0"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
        </a>
      </div>

      <a
        href="https://www.squarebitstudios.com"
        target="_blank"
        rel="noopener noreferrer"
        className="font-body text-[13px] text-[#818185] dark:text-[#A0A0A3] hover:text-base-black dark:hover:text-white transition-colors mt-[20px]"
      >
        www.squarebitstudios.com
      </a>
    </div>
  );
};
